import { createSelector } from 'reselect'

const getAuthState = state => state.auth
export const isAuthenticated = createSelector(getAuthState, auth => auth.authenticated)



// WEBPACK FOOTER //
// ./src/modules/auth/selectors.js